import { render, staticRenderFns } from "./erFormItem.vue?vue&type=template&id=15c1c845&"
import script from "./erFormItem.vue?vue&type=script&lang=js&"
export * from "./erFormItem.vue?vue&type=script&lang=js&"
import style0 from "./erFormItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports